








import Vue from 'vue';
import {
  FooterPrimary,
  FooterSecondary,
  FooterTranslate,
} from '@/components/global-components/global-footer-component/footer-components';

export default Vue.extend({
  name: 'GlobalFooter',
  data() {
    return {
      clientName: process.env.VUE_APP_CLIENT_NAME,
    };
  },
  components: {
    FooterPrimary,
    FooterSecondary,
    FooterTranslate,
  },
});
